// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AdminAppServiceGetAppData, AdminAppServiceGetAppResponses, AdminAppServiceListApiKeysData, AdminAppServiceListApiKeysResponses, AdminAppServiceListAppsData, AdminAppServiceListAppsResponses, AdminAuthServiceChangePasswordData, AdminAuthServiceChangePasswordResponses, AdminAuthServiceLoginData, AdminAuthServiceLoginResponses, AdminAvatarApplyServiceAdminDeleteAvatarApplyData, AdminAvatarApplyServiceAdminDeleteAvatarApplyResponses, AdminAvatarApplyServiceAdminListAvatarAppliesData, AdminAvatarApplyServiceAdminListAvatarAppliesResponses, AdminBillingServiceCreateCreditPackageData, AdminBillingServiceCreateCreditPackageResponses, AdminBillingServiceCreatePlanData, AdminBillingServiceCreatePlanResponses, AdminBillingServiceDeductCreditsData, AdminBillingServiceDeductCreditsResponses, AdminBillingServiceDeleteCreditPackageData, AdminBillingServiceDeleteCreditPackageResponses, AdminBillingServiceDeletePlanData, AdminBillingServiceDeletePlanResponses, AdminBillingServiceGetBillingStatsData, AdminBillingServiceGetBillingStatsResponses, AdminBillingServiceGetPlanData, AdminBillingServiceGetPlanResponses, AdminBillingServiceGetUserCreditBalanceData, AdminBillingServiceGetUserCreditBalanceResponses, AdminBillingServiceGetUserSubscriptionData, AdminBillingServiceGetUserSubscriptionResponses, AdminBillingServiceGrantCreditsData, AdminBillingServiceGrantCreditsResponses, AdminBillingServiceListCreditPackagesData, AdminBillingServiceListCreditPackagesResponses, AdminBillingServiceListCreditTransactionsData, AdminBillingServiceListCreditTransactionsResponses, AdminBillingServiceListPlansData, AdminBillingServiceListPlansResponses, AdminBillingServiceListSubscriptionsData, AdminBillingServiceListSubscriptionsResponses, AdminBillingServiceListUserCreditTransactionsData, AdminBillingServiceListUserCreditTransactionsResponses, AdminBillingServiceListUserCreditUsagesData, AdminBillingServiceListUserCreditUsagesResponses, AdminBillingServiceUpdateCreditPackageData, AdminBillingServiceUpdateCreditPackageResponses, AdminBillingServiceUpdatePlanData, AdminBillingServiceUpdatePlanResponses, AdminBillingServiceUpdateUserSubscriptionData, AdminBillingServiceUpdateUserSubscriptionResponses, AdminConfigServiceAdminAddAvatarQuotaData, AdminConfigServiceAdminAddAvatarQuotaResponses, AdminConfigServiceAdminCreateConfigData, AdminConfigServiceAdminCreateConfigResponses, AdminConfigServiceAdminCreateUserConfigData, AdminConfigServiceAdminCreateUserConfigResponses, AdminConfigServiceAdminDeleteConfigData, AdminConfigServiceAdminDeleteConfigResponses, AdminConfigServiceAdminGetConfigData, AdminConfigServiceAdminGetConfigResponses, AdminConfigServiceAdminGetUserConfigData, AdminConfigServiceAdminGetUserConfigResponses, AdminConfigServiceAdminListConfigsData, AdminConfigServiceAdminListConfigsResponses, AdminConfigServiceAdminListUserConfigsData, AdminConfigServiceAdminListUserConfigsResponses, AdminConfigServiceAdminUpdateConfigData, AdminConfigServiceAdminUpdateConfigResponses, AdminConfigServiceAdminUpdateUserConfigData, AdminConfigServiceAdminUpdateUserConfigResponses, AdminDrivenStatsServiceGetConcurrencyTrendData, AdminDrivenStatsServiceGetConcurrencyTrendResponses, AdminDrivenStatsServiceGetEntityStatsData, AdminDrivenStatsServiceGetEntityStatsResponses, AdminDrivenStatsServiceGetOverviewData, AdminDrivenStatsServiceGetOverviewResponses, AdminDrivenStatsServiceGetRealtimeStatsData, AdminDrivenStatsServiceGetRealtimeStatsResponses, AdminDrivenStatsServiceGetRegionDistributionData, AdminDrivenStatsServiceGetRegionDistributionResponses, AdminDrivenStatsServiceGetTopAppsData, AdminDrivenStatsServiceGetTopAppsResponses, AdminDrivenStatsServiceGetTopUsersData, AdminDrivenStatsServiceGetTopUsersResponses, AdminDrivenStatsServiceGetTrendData, AdminDrivenStatsServiceGetTrendResponses, AdminPublicAvatarServiceAdminCreatePublicAvatarData, AdminPublicAvatarServiceAdminCreatePublicAvatarResponses, AdminPublicAvatarServiceAdminDeletePublicAvatarData, AdminPublicAvatarServiceAdminDeletePublicAvatarResponses, AdminPublicAvatarServiceAdminListPublicAvatarsData, AdminPublicAvatarServiceAdminListPublicAvatarsResponses, AdminPublicAvatarServiceAdminUpdatePublicAvatarData, AdminPublicAvatarServiceAdminUpdatePublicAvatarResponses, AdminUserCharacterServiceAdminCreateUserCharacterData, AdminUserCharacterServiceAdminCreateUserCharacterResponses, AdminUserCharacterServiceAdminDeleteUserCharacterData, AdminUserCharacterServiceAdminDeleteUserCharacterResponses, AdminUserCharacterServiceAdminGetUserCharacterData, AdminUserCharacterServiceAdminGetUserCharacterResponses, AdminUserCharacterServiceAdminListUserCharactersData, AdminUserCharacterServiceAdminListUserCharactersResponses, AdminUserCharacterServiceAdminUpdateUserCharacterData, AdminUserCharacterServiceAdminUpdateUserCharacterResponses, AdminUserServiceCreateAdminUserData, AdminUserServiceCreateAdminUserResponses, AdminUserServiceDeleteAdminUserData, AdminUserServiceDeleteAdminUserResponses, AdminUserServiceListAdminUsersData, AdminUserServiceListAdminUsersResponses, AdminUserServiceListUsersData, AdminUserServiceListUsersResponses, AdminUserServiceUpdateUserRemarkData, AdminUserServiceUpdateUserRemarkResponses, AppServiceCreateApiKeyData, AppServiceCreateApiKeyResponses, AppServiceCreateAppData, AppServiceCreateAppResponses, AppServiceDeleteApiKeyData, AppServiceDeleteApiKeyResponses, AppServiceDeleteAppData, AppServiceDeleteAppResponses, AppServiceGetAppData, AppServiceGetAppResponses, AppServiceListApiKeysData, AppServiceListApiKeysResponses, AppServiceListAppsData, AppServiceListAppsResponses, AsyncProcessingServiceAdjustMaterialAsyncData, AsyncProcessingServiceAdjustMaterialAsyncResponses, AsyncProcessingServiceCreateTaskAsyncData, AsyncProcessingServiceCreateTaskAsyncResponses, AuthServiceChangePasswordData, AuthServiceChangePasswordResponses, AuthServiceGetMeData, AuthServiceGetMeResponses, AuthServiceLoginData, AuthServiceLoginResponses, AuthServiceLogoutData, AuthServiceLogoutResponses, AuthServiceOAuthLoginData, AuthServiceOAuthLoginResponses, AuthServiceRegisterData, AuthServiceRegisterResponses, AuthServiceResetPasswordData, AuthServiceResetPasswordResponses, AuthServiceSendVerificationCodeData, AuthServiceSendVerificationCodeResponses, AuthServiceUpdateProfileData, AuthServiceUpdateProfileResponses, AuthServiceVerifyVerificationCodeData, AuthServiceVerifyVerificationCodeResponses, AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackData, AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackResponses, AvatarServiceCopyAvatarData, AvatarServiceCopyAvatarResponses, AvatarServiceCreateAvatarData, AvatarServiceCreateAvatarResponses, AvatarServiceDeleteAvatarApplyData, AvatarServiceDeleteAvatarApplyResponses, AvatarServiceDeleteAvatarData, AvatarServiceDeleteAvatarResponses, AvatarServiceGetAvatarDetailData, AvatarServiceGetAvatarDetailResponses, AvatarServiceListAvatarAppliesData, AvatarServiceListAvatarAppliesResponses, AvatarServiceListAvatarsData, AvatarServiceListAvatarsResponses, AvatarServiceListDrivenProvidersData, AvatarServiceListDrivenProvidersResponses, AvatarServiceListKlingMotionPresetsData, AvatarServiceListKlingMotionPresetsResponses, AvatarServiceUpdateAvatarData, AvatarServiceUpdateAvatarResponses, BillingServiceCancelSubscriptionData, BillingServiceCancelSubscriptionResponses, BillingServiceCheckSessionPermissionData, BillingServiceCheckSessionPermissionResponses, BillingServiceCreateSubscriptionData, BillingServiceCreateSubscriptionResponses, BillingServiceDowngradeSubscriptionData, BillingServiceDowngradeSubscriptionResponses, BillingServiceGetAutoReloadConfigData, BillingServiceGetAutoReloadConfigResponses, BillingServiceGetCreditBalanceData, BillingServiceGetCreditBalanceResponses, BillingServiceGetCustomerPortalData, BillingServiceGetCustomerPortalResponses, BillingServiceGetSubscriptionData, BillingServiceGetSubscriptionResponses, BillingServiceGetUsageSummaryData, BillingServiceGetUsageSummaryResponses, BillingServiceListCreditPackagesData, BillingServiceListCreditPackagesResponses, BillingServiceListCreditTransactionsData, BillingServiceListCreditTransactionsResponses, BillingServiceListPlansData, BillingServiceListPlansResponses, BillingServicePurchaseCreditPackageData, BillingServicePurchaseCreditPackageResponses, BillingServiceResumeSubscriptionData, BillingServiceResumeSubscriptionResponses, BillingServiceSetupAutoReloadPaymentMethodData, BillingServiceSetupAutoReloadPaymentMethodResponses, BillingServiceUpdateAutoReloadConfigData, BillingServiceUpdateAutoReloadConfigResponses, BillingServiceUpgradeSubscriptionData, BillingServiceUpgradeSubscriptionResponses, CliAuthServiceApproveCliAuthSessionData, CliAuthServiceApproveCliAuthSessionResponses, CliAuthServiceCreateCliAuthSessionData, CliAuthServiceCreateCliAuthSessionResponses, CliAuthServiceExchangeCliAuthTokenData, CliAuthServiceExchangeCliAuthTokenResponses, CliAuthServiceGetCliAuthSessionData, CliAuthServiceGetCliAuthSessionResponses, CliAuthServiceRefreshCliAuthTokenData, CliAuthServiceRefreshCliAuthTokenResponses, CliAuthServiceRevokeCliAuthTokenData, CliAuthServiceRevokeCliAuthTokenResponses, CollectionTaskServiceCreateCollectionTaskData, CollectionTaskServiceCreateCollectionTaskResponses, CollectionTaskServiceDeleteCollectionTaskData, CollectionTaskServiceDeleteCollectionTaskResponses, CollectionTaskServiceGetCollectionTaskByTokenData, CollectionTaskServiceGetCollectionTaskByTokenResponses, CollectionTaskServiceGetCollectionTaskData, CollectionTaskServiceGetCollectionTaskOssCredentialsData, CollectionTaskServiceGetCollectionTaskOssCredentialsResponses, CollectionTaskServiceGetCollectionTaskResponses, CollectionTaskServiceListCollectionTasksData, CollectionTaskServiceListCollectionTasksResponses, CollectionTaskServiceSubmitCollectionFileData, CollectionTaskServiceSubmitCollectionFileResponses, CollectionTaskServiceUpdateCollectionTaskData, CollectionTaskServiceUpdateCollectionTaskResponses, CommonServiceGetR2PresignedPutUrlData, CommonServiceGetR2PresignedPutUrlResponses, ConsoleServiceCreateSessionTokenData, ConsoleServiceCreateSessionTokenResponses, ConsoleServiceGetOssCredentialsData, ConsoleServiceGetOssCredentialsResponses, DrivenStatsServiceGetAllRegionsStatsData, DrivenStatsServiceGetAllRegionsStatsResponses, DrivenStatsServiceGetRegionStatsData, DrivenStatsServiceGetRegionStatsResponses, DrivenStatsServiceSyncDrivenStatsData, DrivenStatsServiceSyncDrivenStatsResponses, FeedbackTicketServiceAdminCreateFeedbackReplyData, FeedbackTicketServiceAdminCreateFeedbackReplyResponses, FeedbackTicketServiceAdminCreateFeedbackTicketData, FeedbackTicketServiceAdminCreateFeedbackTicketResponses, FeedbackTicketServiceAdminGetFeedbackTicketData, FeedbackTicketServiceAdminGetFeedbackTicketResponses, FeedbackTicketServiceAdminListFeedbackTicketsData, FeedbackTicketServiceAdminListFeedbackTicketsResponses, FeedbackTicketServiceAdminUpdateTicketStatusData, FeedbackTicketServiceAdminUpdateTicketStatusResponses, FeedbackTicketServiceCloseFeedbackTicketData, FeedbackTicketServiceCloseFeedbackTicketResponses, FeedbackTicketServiceCreateFeedbackReplyData, FeedbackTicketServiceCreateFeedbackReplyResponses, FeedbackTicketServiceCreateFeedbackTicketData, FeedbackTicketServiceCreateFeedbackTicketResponses, FeedbackTicketServiceGetFeedbackTicketData, FeedbackTicketServiceGetFeedbackTicketResponses, FeedbackTicketServiceListMyFeedbackTicketsData, FeedbackTicketServiceListMyFeedbackTicketsResponses, FeedbackTicketServiceUpdateFeedbackTicketData, FeedbackTicketServiceUpdateFeedbackTicketResponses, InstanceManagementServiceListContainerImagesData, InstanceManagementServiceListContainerImagesResponses, InstanceManagementServiceListContainerImageTagsData, InstanceManagementServiceListContainerImageTagsResponses, InstanceManagementServiceListInstancesData, InstanceManagementServiceListInstancesResponses, InstanceManagementServiceListLaunchTemplatesData, InstanceManagementServiceListLaunchTemplatesResponses, MaterialServiceAdjustMaterialData, MaterialServiceAdjustMaterialResponses, MaterialServiceCreateMaterialData, MaterialServiceCreateMaterialResponses, MaterialServiceDeleteMaterialData, MaterialServiceDeleteMaterialResponses, MaterialServiceGetMaterialData, MaterialServiceGetMaterialResponses, MaterialServiceListMaterialsData, MaterialServiceListMaterialsResponses, MaterialServiceUpdateMaterialData, MaterialServiceUpdateMaterialResponses, PipeTemplateServiceCreatePipeTemplateData, PipeTemplateServiceCreatePipeTemplateResponses, PipeTemplateServiceDeletePipeTemplateData, PipeTemplateServiceDeletePipeTemplateResponses, PipeTemplateServiceGetPipeTemplateData, PipeTemplateServiceGetPipeTemplateResponses, PipeTemplateServiceListPipeTemplatesData, PipeTemplateServiceListPipeTemplatesResponses, PipeTemplateServiceListTrackerVersionsData, PipeTemplateServiceListTrackerVersionsResponses, PipeTemplateServiceUpdatePipeTemplateData, PipeTemplateServiceUpdatePipeTemplateResponses, PublicAvatarServiceListPublicAvatarsData, PublicAvatarServiceListPublicAvatarsResponses, TaskHeartbeatServiceHeartbeatData, TaskHeartbeatServiceHeartbeatResponses, TaskServiceCreateStatusData, TaskServiceCreateStatusResponses, TaskServiceCreateTaskData, TaskServiceCreateTaskResponses, TaskServiceDeleteStatusData, TaskServiceDeleteStatusResponses, TaskServiceDeleteTaskData, TaskServiceDeleteTaskResponses, TaskServiceGetStatusData, TaskServiceGetStatusResponses, TaskServiceGetTaskData, TaskServiceGetTaskResponses, TaskServiceGetTaskStatsData, TaskServiceGetTaskStatsResponses, TaskServiceListStatusesData, TaskServiceListStatusesResponses, TaskServiceListTasksData, TaskServiceListTasksResponses, TaskServiceTerminateTaskInstancesData, TaskServiceTerminateTaskInstancesResponses, TaskServiceUpdateStatusData, TaskServiceUpdateStatusResponses, TaskServiceUpdateTaskData, TaskServiceUpdateTaskResponses, UserDrivenStatsServiceGetRealtimeConcurrentConnectionsData, UserDrivenStatsServiceGetRealtimeConcurrentConnectionsResponses, UserDrivenStatsServiceGetSessionCountData, UserDrivenStatsServiceGetSessionCountResponses, UserDrivenStatsServiceGetUsageData, UserDrivenStatsServiceGetUsageResponses, UserDrivenStatsServiceListConnectionLogsData, UserDrivenStatsServiceListConnectionLogsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * List connection logs for the authenticated user
 */
export const userDrivenStatsServiceListConnectionLogs = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceListConnectionLogsData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceListConnectionLogsResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/connection-logs',
        ...options
    });
};

/**
 * Get realtime concurrent connections for the authenticated user
 */
export const userDrivenStatsServiceGetRealtimeConcurrentConnections = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetRealtimeConcurrentConnectionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceGetRealtimeConcurrentConnectionsResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/realtime-connections',
        ...options
    });
};

/**
 * Get session count time series for the authenticated user
 */
export const userDrivenStatsServiceGetSessionCount = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetSessionCountData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceGetSessionCountResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/session-count',
        ...options
    });
};

/**
 * Get audio usage time series for the authenticated user
 */
export const userDrivenStatsServiceGetUsage = <ThrowOnError extends boolean = false>(options?: Options<UserDrivenStatsServiceGetUsageData, ThrowOnError>) => {
    return (options?.client ?? client).get<UserDrivenStatsServiceGetUsageResponses, unknown, ThrowOnError>({
        url: '/api/console/v2/stats/usage',
        ...options
    });
};

/**
 * Admin-facing
 */
export const feedbackTicketServiceAdminListFeedbackTickets = <ThrowOnError extends boolean = false>(options?: Options<FeedbackTicketServiceAdminListFeedbackTicketsData, ThrowOnError>) => {
    return (options?.client ?? client).get<FeedbackTicketServiceAdminListFeedbackTicketsResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets',
        ...options
    });
};

export const feedbackTicketServiceAdminCreateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminCreateFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceAdminCreateFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceAdminGetFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminGetFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).get<FeedbackTicketServiceAdminGetFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets/{id}',
        ...options
    });
};

export const feedbackTicketServiceAdminUpdateTicketStatus = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminUpdateTicketStatusData, ThrowOnError>) => {
    return (options.client ?? client).patch<FeedbackTicketServiceAdminUpdateTicketStatusResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets/{id}/status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceAdminCreateFeedbackReply = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceAdminCreateFeedbackReplyData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceAdminCreateFeedbackReplyResponses, unknown, ThrowOnError>({
        url: '/api/v1/admin/feedback/tickets/{ticketId}/replies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceListMyFeedbackTickets = <ThrowOnError extends boolean = false>(options?: Options<FeedbackTicketServiceListMyFeedbackTicketsData, ThrowOnError>) => {
    return (options?.client ?? client).get<FeedbackTicketServiceListMyFeedbackTicketsResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets',
        ...options
    });
};

/**
 * User-facing
 */
export const feedbackTicketServiceCreateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCreateFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceCreateFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceGetFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceGetFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).get<FeedbackTicketServiceGetFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{id}',
        ...options
    });
};

export const feedbackTicketServiceUpdateFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceUpdateFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).patch<FeedbackTicketServiceUpdateFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const feedbackTicketServiceCloseFeedbackTicket = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCloseFeedbackTicketData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceCloseFeedbackTicketResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{id}/close',
        ...options
    });
};

export const feedbackTicketServiceCreateFeedbackReply = <ThrowOnError extends boolean = false>(options: Options<FeedbackTicketServiceCreateFeedbackReplyData, ThrowOnError>) => {
    return (options.client ?? client).post<FeedbackTicketServiceCreateFeedbackReplyResponses, unknown, ThrowOnError>({
        url: '/api/v1/feedback/tickets/{ticketId}/replies',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all admin users
 */
export const adminUserServiceListAdminUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminUserServiceListAdminUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminUserServiceListAdminUsersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/admin-users',
        ...options
    });
};

/**
 * Create a new admin user
 */
export const adminUserServiceCreateAdminUser = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceCreateAdminUserData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminUserServiceCreateAdminUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/admin-users',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an admin user
 */
export const adminUserServiceDeleteAdminUser = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceDeleteAdminUserData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminUserServiceDeleteAdminUserResponses, unknown, ThrowOnError>({
        url: '/v1/admin/admin-users/{adminUserId}',
        ...options
    });
};

/**
 * List all API keys with optional app_id and user_id filters
 */
export const adminAppServiceListApiKeys = <ThrowOnError extends boolean = false>(options?: Options<AdminAppServiceListApiKeysData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAppServiceListApiKeysResponses, unknown, ThrowOnError>({
        url: '/v1/admin/api-keys',
        ...options
    });
};

/**
 * List all applications with optional user ID filter
 */
export const adminAppServiceListApps = <ThrowOnError extends boolean = false>(options?: Options<AdminAppServiceListAppsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAppServiceListAppsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/apps',
        ...options
    });
};

/**
 * Get application detail by app_id
 */
export const adminAppServiceGetApp = <ThrowOnError extends boolean = false>(options: Options<AdminAppServiceGetAppData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminAppServiceGetAppResponses, unknown, ThrowOnError>({
        url: '/v1/admin/apps/{appId}',
        ...options
    });
};

/**
 * Change password
 */
export const adminAuthServiceChangePassword = <ThrowOnError extends boolean = false>(options: Options<AdminAuthServiceChangePasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAuthServiceChangePasswordResponses, unknown, ThrowOnError>({
        url: '/v1/admin/auth/change-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Login with email and password
 */
export const adminAuthServiceLogin = <ThrowOnError extends boolean = false>(options: Options<AdminAuthServiceLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminAuthServiceLoginResponses, unknown, ThrowOnError>({
        url: '/v1/admin/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all console configs
 */
export const adminConfigServiceAdminListConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminConfigServiceAdminListConfigsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminConfigServiceAdminListConfigsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs',
        ...options
    });
};

/**
 * Create a new console config
 */
export const adminConfigServiceAdminCreateConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminCreateConfigData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminConfigServiceAdminCreateConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a console config
 */
export const adminConfigServiceAdminDeleteConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminDeleteConfigData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminConfigServiceAdminDeleteConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs/{key}',
        ...options
    });
};

/**
 * Get console config by key
 */
export const adminConfigServiceAdminGetConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminGetConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminConfigServiceAdminGetConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs/{key}',
        ...options
    });
};

/**
 * Update an existing console config
 */
export const adminConfigServiceAdminUpdateConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminUpdateConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminConfigServiceAdminUpdateConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/configs/{key}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * GetAllRegionsStats returns aggregated real-time stats from all regions
 * Only available on the primary Console (SV), aggregates data from BJ, TYO, SV
 */
export const drivenStatsServiceGetAllRegionsStats = <ThrowOnError extends boolean = false>(options?: Options<DrivenStatsServiceGetAllRegionsStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<DrivenStatsServiceGetAllRegionsStatsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/driven-stats/all-regions',
        ...options
    });
};

/**
 * List all console user characters with optional filters
 */
export const adminUserCharacterServiceAdminListUserCharacters = <ThrowOnError extends boolean = false>(options?: Options<AdminUserCharacterServiceAdminListUserCharactersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminUserCharacterServiceAdminListUserCharactersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters',
        ...options
    });
};

/**
 * Create a new console user character
 */
export const adminUserCharacterServiceAdminCreateUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminCreateUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminUserCharacterServiceAdminCreateUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a console user character
 */
export const adminUserCharacterServiceAdminDeleteUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminDeleteUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminUserCharacterServiceAdminDeleteUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters/{id}',
        ...options
    });
};

/**
 * Get console user character by ID
 */
export const adminUserCharacterServiceAdminGetUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminGetUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminUserCharacterServiceAdminGetUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters/{id}',
        ...options
    });
};

/**
 * Update an existing console user character
 */
export const adminUserCharacterServiceAdminUpdateUserCharacter = <ThrowOnError extends boolean = false>(options: Options<AdminUserCharacterServiceAdminUpdateUserCharacterData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUserCharacterServiceAdminUpdateUserCharacterResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-characters/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all console user configs with optional user_id filter
 */
export const adminConfigServiceAdminListUserConfigs = <ThrowOnError extends boolean = false>(options?: Options<AdminConfigServiceAdminListUserConfigsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminConfigServiceAdminListUserConfigsResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs',
        ...options
    });
};

/**
 * Create a new console user config
 */
export const adminConfigServiceAdminCreateUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminCreateUserConfigData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminConfigServiceAdminCreateUserConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get console user config by user_id
 */
export const adminConfigServiceAdminGetUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminGetUserConfigData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminConfigServiceAdminGetUserConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs/{userId}',
        ...options
    });
};

/**
 * Update console user config
 */
export const adminConfigServiceAdminUpdateUserConfig = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminUpdateUserConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminConfigServiceAdminUpdateUserConfigResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Add avatar generation quota to a user
 */
export const adminConfigServiceAdminAddAvatarQuota = <ThrowOnError extends boolean = false>(options: Options<AdminConfigServiceAdminAddAvatarQuotaData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminConfigServiceAdminAddAvatarQuotaResponses, unknown, ThrowOnError>({
        url: '/v1/admin/user-configs/{userId}/add-quota',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all console users
 */
export const adminUserServiceListUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminUserServiceListUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminUserServiceListUsersResponses, unknown, ThrowOnError>({
        url: '/v1/admin/users',
        ...options
    });
};

/**
 * Update remark for a console user
 */
export const adminUserServiceUpdateUserRemark = <ThrowOnError extends boolean = false>(options: Options<AdminUserServiceUpdateUserRemarkData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminUserServiceUpdateUserRemarkResponses, unknown, ThrowOnError>({
        url: '/v1/admin/users/{userId}/remark',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all applications with pagination
 */
export const appServiceListApps = <ThrowOnError extends boolean = false>(options?: Options<AppServiceListAppsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AppServiceListAppsResponses, unknown, ThrowOnError>({
        url: '/v1/apps',
        ...options
    });
};

/**
 * Create a new application
 */
export const appServiceCreateApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceCreateAppData, ThrowOnError>) => {
    return (options.client ?? client).post<AppServiceCreateAppResponses, unknown, ThrowOnError>({
        url: '/v1/apps',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete an application and all its associated API keys
 */
export const appServiceDeleteApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceDeleteAppData, ThrowOnError>) => {
    return (options.client ?? client).delete<AppServiceDeleteAppResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}',
        ...options
    });
};

/**
 * Get a specific application by ID
 */
export const appServiceGetApp = <ThrowOnError extends boolean = false>(options: Options<AppServiceGetAppData, ThrowOnError>) => {
    return (options.client ?? client).get<AppServiceGetAppResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}',
        ...options
    });
};

/**
 * List all API keys for an application
 */
export const appServiceListApiKeys = <ThrowOnError extends boolean = false>(options: Options<AppServiceListApiKeysData, ThrowOnError>) => {
    return (options.client ?? client).get<AppServiceListApiKeysResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}/api-keys',
        ...options
    });
};

/**
 * Create a new API key for an application
 */
export const appServiceCreateApiKey = <ThrowOnError extends boolean = false>(options: Options<AppServiceCreateApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).post<AppServiceCreateApiKeyResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}/api-keys',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete a specific API key
 */
export const appServiceDeleteApiKey = <ThrowOnError extends boolean = false>(options: Options<AppServiceDeleteApiKeyData, ThrowOnError>) => {
    return (options.client ?? client).delete<AppServiceDeleteApiKeyResponses, unknown, ThrowOnError>({
        url: '/v1/apps/{appId}/api-keys/{apiKey}',
        ...options
    });
};

/**
 * Change password
 */
export const authServiceChangePassword = <ThrowOnError extends boolean = false>(options: Options<AuthServiceChangePasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceChangePasswordResponses, unknown, ThrowOnError>({
        url: '/v1/auth/change-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Login with email and password
 */
export const authServiceLogin = <ThrowOnError extends boolean = false>(options: Options<AuthServiceLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceLoginResponses, unknown, ThrowOnError>({
        url: '/v1/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Logout (optional, mainly for token invalidation)
 */
export const authServiceLogout = <ThrowOnError extends boolean = false>(options: Options<AuthServiceLogoutData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceLogoutResponses, unknown, ThrowOnError>({
        url: '/v1/auth/logout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get current user information
 */
export const authServiceGetMe = <ThrowOnError extends boolean = false>(options?: Options<AuthServiceGetMeData, ThrowOnError>) => {
    return (options?.client ?? client).get<AuthServiceGetMeResponses, unknown, ThrowOnError>({
        url: '/v1/auth/me',
        ...options
    });
};

/**
 * Login or register with OAuth
 */
export const authServiceOAuthLogin = <ThrowOnError extends boolean = false>(options: Options<AuthServiceOAuthLoginData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceOAuthLoginResponses, unknown, ThrowOnError>({
        url: '/v1/auth/oauth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reset password using verification code
 */
export const authServiceResetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthServiceResetPasswordData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceResetPasswordResponses, unknown, ThrowOnError>({
        url: '/v1/auth/password-reset/reset',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update user profile
 */
export const authServiceUpdateProfile = <ThrowOnError extends boolean = false>(options: Options<AuthServiceUpdateProfileData, ThrowOnError>) => {
    return (options.client ?? client).put<AuthServiceUpdateProfileResponses, unknown, ThrowOnError>({
        url: '/v1/auth/profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Register a new user with email and password
 */
export const authServiceRegister = <ThrowOnError extends boolean = false>(options: Options<AuthServiceRegisterData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceRegisterResponses, unknown, ThrowOnError>({
        url: '/v1/auth/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Send an email verification code
 */
export const authServiceSendVerificationCode = <ThrowOnError extends boolean = false>(options: Options<AuthServiceSendVerificationCodeData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceSendVerificationCodeResponses, unknown, ThrowOnError>({
        url: '/v1/auth/verification-code/send',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Verify an email verification code
 */
export const authServiceVerifyVerificationCode = <ThrowOnError extends boolean = false>(options: Options<AuthServiceVerifyVerificationCodeData, ThrowOnError>) => {
    return (options.client ?? client).post<AuthServiceVerifyVerificationCodeResponses, unknown, ThrowOnError>({
        url: '/v1/auth/verification-code/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Create a short-lived browser authorization session for CLI login.
 */
export const cliAuthServiceCreateCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceCreateCliAuthSessionData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceCreateCliAuthSessionResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/sessions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Retrieve session details for the open-platform-web authorization page.
 */
export const cliAuthServiceGetCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceGetCliAuthSessionData, ThrowOnError>) => {
    return (options.client ?? client).get<CliAuthServiceGetCliAuthSessionResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/sessions/{authRequestId}',
        ...options
    });
};

/**
 * Approve the session from the logged-in web page and produce the final loopback redirect URL.
 */
export const cliAuthServiceApproveCliAuthSession = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceApproveCliAuthSessionData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceApproveCliAuthSessionResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/sessions/{authRequestId}:approve',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Exchange auth code plus PKCE verifier for CLI tokens.
 */
export const cliAuthServiceExchangeCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceExchangeCliAuthTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceExchangeCliAuthTokenResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh an expired access token by refresh token.
 */
export const cliAuthServiceRefreshCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceRefreshCliAuthTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceRefreshCliAuthTokenResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/token:refresh',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Revoke CLI tokens during logout.
 */
export const cliAuthServiceRevokeCliAuthToken = <ThrowOnError extends boolean = false>(options: Options<CliAuthServiceRevokeCliAuthTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<CliAuthServiceRevokeCliAuthTokenResponses, unknown, ThrowOnError>({
        url: '/v1/cli/auth/token:revoke',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const collectionTaskServiceListCollectionTasks = <ThrowOnError extends boolean = false>(options?: Options<CollectionTaskServiceListCollectionTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<CollectionTaskServiceListCollectionTasksResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks',
        ...options
    });
};

/**
 * CollectionTask operations
 */
export const collectionTaskServiceCreateCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceCreateCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<CollectionTaskServiceCreateCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const collectionTaskServiceDeleteCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceDeleteCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).delete<CollectionTaskServiceDeleteCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks/{id}',
        ...options
    });
};

export const collectionTaskServiceGetCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).get<CollectionTaskServiceGetCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks/{id}',
        ...options
    });
};

export const collectionTaskServiceUpdateCollectionTask = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceUpdateCollectionTaskData, ThrowOnError>) => {
    return (options.client ?? client).put<CollectionTaskServiceUpdateCollectionTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/collection-tasks/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取容器镜像列表
 */
export const instanceManagementServiceListContainerImages = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListContainerImagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<InstanceManagementServiceListContainerImagesResponses, unknown, ThrowOnError>({
        url: '/v1/console/container-images',
        ...options
    });
};

/**
 * 获取容器镜像标签列表
 */
export const instanceManagementServiceListContainerImageTags = <ThrowOnError extends boolean = false>(options: Options<InstanceManagementServiceListContainerImageTagsData, ThrowOnError>) => {
    return (options.client ?? client).get<InstanceManagementServiceListContainerImageTagsResponses, unknown, ThrowOnError>({
        url: '/v1/console/container-images/{namespace}/{repositoryName}/tags',
        ...options
    });
};

/**
 * 获取实例列表
 */
export const instanceManagementServiceListInstances = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListInstancesData, ThrowOnError>) => {
    return (options?.client ?? client).get<InstanceManagementServiceListInstancesResponses, unknown, ThrowOnError>({
        url: '/v1/console/instances',
        ...options
    });
};

/**
 * 获取启动模板列表
 */
export const instanceManagementServiceListLaunchTemplates = <ThrowOnError extends boolean = false>(options?: Options<InstanceManagementServiceListLaunchTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<InstanceManagementServiceListLaunchTemplatesResponses, unknown, ThrowOnError>({
        url: '/v1/console/launch-templates',
        ...options
    });
};

export const materialServiceListMaterials = <ThrowOnError extends boolean = false>(options?: Options<MaterialServiceListMaterialsData, ThrowOnError>) => {
    return (options?.client ?? client).get<MaterialServiceListMaterialsResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials',
        ...options
    });
};

export const materialServiceCreateMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceCreateMaterialData, ThrowOnError>) => {
    return (options.client ?? client).post<MaterialServiceCreateMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const materialServiceDeleteMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceDeleteMaterialData, ThrowOnError>) => {
    return (options.client ?? client).delete<MaterialServiceDeleteMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}',
        ...options
    });
};

export const materialServiceGetMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceGetMaterialData, ThrowOnError>) => {
    return (options.client ?? client).get<MaterialServiceGetMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}',
        ...options
    });
};

export const materialServiceUpdateMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceUpdateMaterialData, ThrowOnError>) => {
    return (options.client ?? client).put<MaterialServiceUpdateMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const materialServiceAdjustMaterial = <ThrowOnError extends boolean = false>(options: Options<MaterialServiceAdjustMaterialData, ThrowOnError>) => {
    return (options.client ?? client).post<MaterialServiceAdjustMaterialResponses, unknown, ThrowOnError>({
        url: '/v1/console/materials/{id}/adjust',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const consoleServiceGetOssCredentials = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceGetOssCredentialsData, ThrowOnError>) => {
    return (options.client ?? client).post<ConsoleServiceGetOssCredentialsResponses, unknown, ThrowOnError>({
        url: '/v1/console/oss-credentials',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const pipeTemplateServiceListPipeTemplates = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListPipeTemplatesData, ThrowOnError>) => {
    return (options?.client ?? client).get<PipeTemplateServiceListPipeTemplatesResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates',
        ...options
    });
};

export const pipeTemplateServiceCreatePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceCreatePipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).post<PipeTemplateServiceCreatePipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const pipeTemplateServiceListTrackerVersions = <ThrowOnError extends boolean = false>(options?: Options<PipeTemplateServiceListTrackerVersionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<PipeTemplateServiceListTrackerVersionsResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/tracker-versions',
        ...options
    });
};

export const pipeTemplateServiceDeletePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceDeletePipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).delete<PipeTemplateServiceDeletePipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/{id}',
        ...options
    });
};

export const pipeTemplateServiceGetPipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceGetPipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).get<PipeTemplateServiceGetPipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/{id}',
        ...options
    });
};

export const pipeTemplateServiceUpdatePipeTemplate = <ThrowOnError extends boolean = false>(options: Options<PipeTemplateServiceUpdatePipeTemplateData, ThrowOnError>) => {
    return (options.client ?? client).put<PipeTemplateServiceUpdatePipeTemplateResponses, unknown, ThrowOnError>({
        url: '/v1/console/pipe-templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const consoleServiceCreateSessionToken = <ThrowOnError extends boolean = false>(options: Options<ConsoleServiceCreateSessionTokenData, ThrowOnError>) => {
    return (options.client ?? client).post<ConsoleServiceCreateSessionTokenResponses, unknown, ThrowOnError>({
        url: '/v1/console/session-tokens',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskServiceListStatuses = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListStatusesData, ThrowOnError>) => {
    return (options?.client ?? client).get<TaskServiceListStatusesResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses',
        ...options
    });
};

/**
 * Status operations
 */
export const taskServiceCreateStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateStatusData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskServiceCreateStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskServiceDeleteStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteStatusData, ThrowOnError>) => {
    return (options.client ?? client).delete<TaskServiceDeleteStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses/{id}',
        ...options
    });
};

export const taskServiceGetStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetStatusData, ThrowOnError>) => {
    return (options.client ?? client).get<TaskServiceGetStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses/{id}',
        ...options
    });
};

export const taskServiceUpdateStatus = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateStatusData, ThrowOnError>) => {
    return (options.client ?? client).put<TaskServiceUpdateStatusResponses, unknown, ThrowOnError>({
        url: '/v1/console/statuses/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskServiceListTasks = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceListTasksData, ThrowOnError>) => {
    return (options?.client ?? client).get<TaskServiceListTasksResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks',
        ...options
    });
};

/**
 * Task operations
 */
export const taskServiceCreateTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceCreateTaskData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskServiceCreateTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get task statistics
 */
export const taskServiceGetTaskStats = <ThrowOnError extends boolean = false>(options?: Options<TaskServiceGetTaskStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<TaskServiceGetTaskStatsResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/stats',
        ...options
    });
};

export const taskServiceDeleteTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceDeleteTaskData, ThrowOnError>) => {
    return (options.client ?? client).delete<TaskServiceDeleteTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}',
        ...options
    });
};

export const taskServiceGetTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceGetTaskData, ThrowOnError>) => {
    return (options.client ?? client).get<TaskServiceGetTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}',
        ...options
    });
};

export const taskServiceUpdateTask = <ThrowOnError extends boolean = false>(options: Options<TaskServiceUpdateTaskData, ThrowOnError>) => {
    return (options.client ?? client).put<TaskServiceUpdateTaskResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Terminate task instances
 */
export const taskServiceTerminateTaskInstances = <ThrowOnError extends boolean = false>(options: Options<TaskServiceTerminateTaskInstancesData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskServiceTerminateTaskInstancesResponses, unknown, ThrowOnError>({
        url: '/v1/console/tasks/{id}/terminate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * GetRegionStats returns this region's real-time stats from local driven-ingress
 * Called by other regions' Console to fetch local stats
 */
export const drivenStatsServiceGetRegionStats = <ThrowOnError extends boolean = false>(options?: Options<DrivenStatsServiceGetRegionStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<DrivenStatsServiceGetRegionStatsResponses, unknown, ThrowOnError>({
        url: '/v1/internal/driven-stats/region',
        ...options
    });
};

/**
 * SyncDrivenStats syncs usage and concurrency stats from remote regions to the primary database
 * This endpoint is called by remote region backup jobs
 */
export const drivenStatsServiceSyncDrivenStats = <ThrowOnError extends boolean = false>(options: Options<DrivenStatsServiceSyncDrivenStatsData, ThrowOnError>) => {
    return (options.client ?? client).post<DrivenStatsServiceSyncDrivenStatsResponses, unknown, ThrowOnError>({
        url: '/v1/internal/driven-stats/sync',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get collection task by share token
 */
export const collectionTaskServiceGetCollectionTaskByToken = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskByTokenData, ThrowOnError>) => {
    return (options.client ?? client).get<CollectionTaskServiceGetCollectionTaskByTokenResponses, unknown, ThrowOnError>({
        url: '/v1/public/collection-tasks/{token}',
        ...options
    });
};

/**
 * Get OSS credentials for file upload
 */
export const collectionTaskServiceGetCollectionTaskOssCredentials = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceGetCollectionTaskOssCredentialsData, ThrowOnError>) => {
    return (options.client ?? client).post<CollectionTaskServiceGetCollectionTaskOssCredentialsResponses, unknown, ThrowOnError>({
        url: '/v1/public/collection-tasks/{token}/oss-credentials',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Submit uploaded file and create material
 */
export const collectionTaskServiceSubmitCollectionFile = <ThrowOnError extends boolean = false>(options: Options<CollectionTaskServiceSubmitCollectionFileData, ThrowOnError>) => {
    return (options.client ?? client).post<CollectionTaskServiceSubmitCollectionFileResponses, unknown, ThrowOnError>({
        url: '/v1/public/collection-tasks/{token}/submit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const taskHeartbeatServiceHeartbeat = <ThrowOnError extends boolean = false>(options: Options<TaskHeartbeatServiceHeartbeatData, ThrowOnError>) => {
    return (options.client ?? client).post<TaskHeartbeatServiceHeartbeatResponses, unknown, ThrowOnError>({
        url: '/v1/task-heartbeat/{instanceId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List all avatar applies with user information
 */
export const adminAvatarApplyServiceAdminListAvatarApplies = <ThrowOnError extends boolean = false>(options?: Options<AdminAvatarApplyServiceAdminListAvatarAppliesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminAvatarApplyServiceAdminListAvatarAppliesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-applies',
        ...options
    });
};

/**
 * Delete an avatar apply record
 */
export const adminAvatarApplyServiceAdminDeleteAvatarApply = <ThrowOnError extends boolean = false>(options: Options<AdminAvatarApplyServiceAdminDeleteAvatarApplyData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminAvatarApplyServiceAdminDeleteAvatarApplyResponses, unknown, ThrowOnError>({
        url: '/v2/admin/avatar-applies/{id}',
        ...options
    });
};

/**
 * 获取所有充值包（包含未上架的）
 */
export const adminBillingServiceListCreditPackages = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListCreditPackagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListCreditPackagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages',
        ...options
    });
};

/**
 * 创建充值包
 */
export const adminBillingServiceCreateCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceCreateCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceCreateCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除充值包（软删除）
 */
export const adminBillingServiceDeleteCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeleteCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminBillingServiceDeleteCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages/{packageId}',
        ...options
    });
};

/**
 * 更新充值包
 */
export const adminBillingServiceUpdateCreditPackage = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdateCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminBillingServiceUpdateCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credit-packages/{packageId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 扣减用户 Credits
 */
export const adminBillingServiceDeductCredits = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeductCreditsData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceDeductCreditsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credits/deduct',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 赠送 Credits 给用户
 */
export const adminBillingServiceGrantCredits = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGrantCreditsData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceGrantCreditsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credits/grant',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取所有 Credits 流水（支持 user_id / type 筛选）
 */
export const adminBillingServiceListCreditTransactions = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListCreditTransactionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListCreditTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/credits/transactions',
        ...options
    });
};

/**
 * 获取所有订阅计划（包含非公开的）
 */
export const adminBillingServiceListPlans = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListPlansData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListPlansResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans',
        ...options
    });
};

/**
 * 创建订阅计划
 */
export const adminBillingServiceCreatePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceCreatePlanData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminBillingServiceCreatePlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除订阅计划（软删除）
 */
export const adminBillingServiceDeletePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceDeletePlanData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminBillingServiceDeletePlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans/{planId}',
        ...options
    });
};

/**
 * 获取单个订阅计划详情
 */
export const adminBillingServiceGetPlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetPlanData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceGetPlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans/{planId}',
        ...options
    });
};

/**
 * 更新订阅计划
 */
export const adminBillingServiceUpdatePlan = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdatePlanData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminBillingServiceUpdatePlanResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/plans/{planId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取计费统计概览
 */
export const adminBillingServiceGetBillingStats = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceGetBillingStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceGetBillingStatsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/stats',
        ...options
    });
};

/**
 * 获取所有用户订阅列表
 */
export const adminBillingServiceListSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<AdminBillingServiceListSubscriptionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminBillingServiceListSubscriptionsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/subscriptions',
        ...options
    });
};

/**
 * 获取用户 Credits 余额
 */
export const adminBillingServiceGetUserCreditBalance = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetUserCreditBalanceData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceGetUserCreditBalanceResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/credits',
        ...options
    });
};

/**
 * 获取用户 Credits 交易记录
 */
export const adminBillingServiceListUserCreditTransactions = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceListUserCreditTransactionsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceListUserCreditTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/credits/transactions',
        ...options
    });
};

/**
 * 获取用户消费明细
 */
export const adminBillingServiceListUserCreditUsages = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceListUserCreditUsagesData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceListUserCreditUsagesResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/credits/usages',
        ...options
    });
};

/**
 * 获取指定用户的订阅信息
 */
export const adminBillingServiceGetUserSubscription = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceGetUserSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminBillingServiceGetUserSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/subscription',
        ...options
    });
};

/**
 * 更新用户订阅（管理员强制变更）
 */
export const adminBillingServiceUpdateUserSubscription = <ThrowOnError extends boolean = false>(options: Options<AdminBillingServiceUpdateUserSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminBillingServiceUpdateUserSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/admin/billing/users/{userId}/subscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get concurrency trend data
 */
export const adminDrivenStatsServiceGetConcurrencyTrend = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetConcurrencyTrendData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetConcurrencyTrendResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/concurrency-trend',
        ...options
    });
};

/**
 * Get detailed stats for a specific entity (region, app, or user)
 */
export const adminDrivenStatsServiceGetEntityStats = <ThrowOnError extends boolean = false>(options: Options<AdminDrivenStatsServiceGetEntityStatsData, ThrowOnError>) => {
    return (options.client ?? client).get<AdminDrivenStatsServiceGetEntityStatsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/entity/{entityType}/{entityId}',
        ...options
    });
};

/**
 * Get overview statistics (top stat cards)
 */
export const adminDrivenStatsServiceGetOverview = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetOverviewData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetOverviewResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/overview',
        ...options
    });
};

/**
 * Get real-time stats from driveningress service
 */
export const adminDrivenStatsServiceGetRealtimeStats = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetRealtimeStatsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetRealtimeStatsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/realtime',
        ...options
    });
};

/**
 * Get region distribution data (for pie chart)
 */
export const adminDrivenStatsServiceGetRegionDistribution = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetRegionDistributionData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetRegionDistributionResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/region-distribution',
        ...options
    });
};

/**
 * Get top apps by usage
 */
export const adminDrivenStatsServiceGetTopApps = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTopAppsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetTopAppsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/top-apps',
        ...options
    });
};

/**
 * Get top users by usage
 */
export const adminDrivenStatsServiceGetTopUsers = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTopUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetTopUsersResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/top-users',
        ...options
    });
};

/**
 * Get usage trend data (time series)
 */
export const adminDrivenStatsServiceGetTrend = <ThrowOnError extends boolean = false>(options?: Options<AdminDrivenStatsServiceGetTrendData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminDrivenStatsServiceGetTrendResponses, unknown, ThrowOnError>({
        url: '/v2/admin/driven-stats/trend',
        ...options
    });
};

/**
 * 列出所有公共Avatar，支持可选过滤
 */
export const adminPublicAvatarServiceAdminListPublicAvatars = <ThrowOnError extends boolean = false>(options?: Options<AdminPublicAvatarServiceAdminListPublicAvatarsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AdminPublicAvatarServiceAdminListPublicAvatarsResponses, unknown, ThrowOnError>({
        url: '/v2/admin/public-avatars',
        ...options
    });
};

/**
 * 创建新的公共Avatar
 */
export const adminPublicAvatarServiceAdminCreatePublicAvatar = <ThrowOnError extends boolean = false>(options: Options<AdminPublicAvatarServiceAdminCreatePublicAvatarData, ThrowOnError>) => {
    return (options.client ?? client).post<AdminPublicAvatarServiceAdminCreatePublicAvatarResponses, unknown, ThrowOnError>({
        url: '/v2/admin/public-avatars',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除公共Avatar
 */
export const adminPublicAvatarServiceAdminDeletePublicAvatar = <ThrowOnError extends boolean = false>(options: Options<AdminPublicAvatarServiceAdminDeletePublicAvatarData, ThrowOnError>) => {
    return (options.client ?? client).delete<AdminPublicAvatarServiceAdminDeletePublicAvatarResponses, unknown, ThrowOnError>({
        url: '/v2/admin/public-avatars/{id}',
        ...options
    });
};

/**
 * 更新现有的公共Avatar
 */
export const adminPublicAvatarServiceAdminUpdatePublicAvatar = <ThrowOnError extends boolean = false>(options: Options<AdminPublicAvatarServiceAdminUpdatePublicAvatarData, ThrowOnError>) => {
    return (options.client ?? client).put<AdminPublicAvatarServiceAdminUpdatePublicAvatarResponses, unknown, ThrowOnError>({
        url: '/v2/admin/public-avatars/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取自动充值配置
 */
export const billingServiceGetAutoReloadConfig = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetAutoReloadConfigData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetAutoReloadConfigResponses, unknown, ThrowOnError>({
        url: '/v2/billing/auto-reload',
        ...options
    });
};

/**
 * 更新自动充值配置
 */
export const billingServiceUpdateAutoReloadConfig = <ThrowOnError extends boolean = false>(options: Options<BillingServiceUpdateAutoReloadConfigData, ThrowOnError>) => {
    return (options.client ?? client).put<BillingServiceUpdateAutoReloadConfigResponses, unknown, ThrowOnError>({
        url: '/v2/billing/auto-reload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 设置自动充值支付方式（返回 Stripe SetupIntent client_secret）
 */
export const billingServiceSetupAutoReloadPaymentMethod = <ThrowOnError extends boolean = false>(options: Options<BillingServiceSetupAutoReloadPaymentMethodData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceSetupAutoReloadPaymentMethodResponses, unknown, ThrowOnError>({
        url: '/v2/billing/auto-reload/setup-payment',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取可用充值包列表
 */
export const billingServiceListCreditPackages = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListCreditPackagesData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceListCreditPackagesResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credit-packages',
        ...options
    });
};

/**
 * 手动购买充值包（返回 Stripe Checkout URL）
 */
export const billingServicePurchaseCreditPackage = <ThrowOnError extends boolean = false>(options: Options<BillingServicePurchaseCreditPackageData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServicePurchaseCreditPackageResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credit-packages/purchase',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取 Credits 余额
 */
export const billingServiceGetCreditBalance = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetCreditBalanceData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetCreditBalanceResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credits',
        ...options
    });
};

/**
 * 获取 Credits 交易记录
 */
export const billingServiceListCreditTransactions = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListCreditTransactionsData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceListCreditTransactionsResponses, unknown, ThrowOnError>({
        url: '/v2/billing/credits/transactions',
        ...options
    });
};

/**
 * 获取 Stripe 客户门户链接
 */
export const billingServiceGetCustomerPortal = <ThrowOnError extends boolean = false>(options: Options<BillingServiceGetCustomerPortalData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceGetCustomerPortalResponses, unknown, ThrowOnError>({
        url: '/v2/billing/customer-portal',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取可用订阅计划列表
 */
export const billingServiceListPlans = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceListPlansData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceListPlansResponses, unknown, ThrowOnError>({
        url: '/v2/billing/plans',
        ...options
    });
};

/**
 * 检查是否可以开启新 Session
 */
export const billingServiceCheckSessionPermission = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCheckSessionPermissionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceCheckSessionPermissionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/session/check',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取当前用户的订阅信息
 */
export const billingServiceGetSubscription = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetSubscriptionData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription',
        ...options
    });
};

/**
 * 创建新订阅（返回 Stripe Checkout URL）
 */
export const billingServiceCreateSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCreateSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceCreateSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 取消订阅
 */
export const billingServiceCancelSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceCancelSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceCancelSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 降级订阅计划（下个周期生效）
 */
export const billingServiceDowngradeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceDowngradeSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceDowngradeSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/downgrade',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 恢复已取消的订阅
 */
export const billingServiceResumeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceResumeSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceResumeSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/resume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 升级订阅计划
 */
export const billingServiceUpgradeSubscription = <ThrowOnError extends boolean = false>(options: Options<BillingServiceUpgradeSubscriptionData, ThrowOnError>) => {
    return (options.client ?? client).post<BillingServiceUpgradeSubscriptionResponses, unknown, ThrowOnError>({
        url: '/v2/billing/subscription/upgrade',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 获取使用摘要
 */
export const billingServiceGetUsageSummary = <ThrowOnError extends boolean = false>(options?: Options<BillingServiceGetUsageSummaryData, ThrowOnError>) => {
    return (options?.client ?? client).get<BillingServiceGetUsageSummaryResponses, unknown, ThrowOnError>({
        url: '/v2/billing/usage',
        ...options
    });
};

/**
 * AI 素材调整（不写表，只做计算处理）
 */
export const asyncProcessingServiceAdjustMaterialAsync = <ThrowOnError extends boolean = false>(options: Options<AsyncProcessingServiceAdjustMaterialAsyncData, ThrowOnError>) => {
    return (options.client ?? client).post<AsyncProcessingServiceAdjustMaterialAsyncResponses, unknown, ThrowOnError>({
        url: '/v2/console/async-processing/adjust-material',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 创建异步任务（视频生成或重建任务，不写表，只做计算处理）
 */
export const asyncProcessingServiceCreateTaskAsync = <ThrowOnError extends boolean = false>(options: Options<AsyncProcessingServiceCreateTaskAsyncData, ThrowOnError>) => {
    return (options.client ?? client).post<AsyncProcessingServiceCreateTaskAsyncResponses, unknown, ThrowOnError>({
        url: '/v2/console/async-processing/create-task',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 列表Avatar申请
 */
export const avatarServiceListAvatarApplies = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatarAppliesData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListAvatarAppliesResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar-applies',
        ...options
    });
};

/**
 * 删除Avatar申请
 */
export const avatarServiceDeleteAvatarApply = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceDeleteAvatarApplyData, ThrowOnError>) => {
    return (options.client ?? client).delete<AvatarServiceDeleteAvatarApplyResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar-applies/{applyId}',
        ...options
    });
};

/**
 * 接收 Realtime 的回调
 */
export const avatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallback = <ThrowOnError extends boolean = false>(options: Options<AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarGenerateTaskCallbackServiceHandleAvatarGenerateTaskCallbackResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatar-generate-task/callback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 列出角色
 */
export const avatarServiceListAvatars = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListAvatarsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListAvatarsResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars',
        ...options
    });
};

/**
 * 申请创建角色
 */
export const avatarServiceCreateAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCreateAvatarData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCreateAvatarResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 删除角色
 */
export const avatarServiceDeleteAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceDeleteAvatarData, ThrowOnError>) => {
    return (options.client ?? client).delete<AvatarServiceDeleteAvatarResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}',
        ...options
    });
};

/**
 * 获取角色详情
 */
export const avatarServiceGetAvatarDetail = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceGetAvatarDetailData, ThrowOnError>) => {
    return (options.client ?? client).get<AvatarServiceGetAvatarDetailResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}',
        ...options
    });
};

/**
 * 编辑角色
 */
export const avatarServiceUpdateAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceUpdateAvatarData, ThrowOnError>) => {
    return (options.client ?? client).patch<AvatarServiceUpdateAvatarResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 复制角色
 */
export const avatarServiceCopyAvatar = <ThrowOnError extends boolean = false>(options: Options<AvatarServiceCopyAvatarData, ThrowOnError>) => {
    return (options.client ?? client).post<AvatarServiceCopyAvatarResponses, unknown, ThrowOnError>({
        url: '/v2/console/avatars/{id}/copy',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * 列表 DPT 驱动 Provider
 */
export const avatarServiceListDrivenProviders = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListDrivenProvidersData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListDrivenProvidersResponses, unknown, ThrowOnError>({
        url: '/v2/console/driven-providers',
        ...options
    });
};

/**
 * 列出 kling 驱动视频
 */
export const avatarServiceListKlingMotionPresets = <ThrowOnError extends boolean = false>(options?: Options<AvatarServiceListKlingMotionPresetsData, ThrowOnError>) => {
    return (options?.client ?? client).get<AvatarServiceListKlingMotionPresetsResponses, unknown, ThrowOnError>({
        url: '/v2/console/kling-motion-presets',
        ...options
    });
};

/**
 * 列出所有公共Avatar
 */
export const publicAvatarServiceListPublicAvatars = <ThrowOnError extends boolean = false>(options?: Options<PublicAvatarServiceListPublicAvatarsData, ThrowOnError>) => {
    return (options?.client ?? client).get<PublicAvatarServiceListPublicAvatarsResponses, unknown, ThrowOnError>({
        url: '/v2/console/public-avatars',
        ...options
    });
};

/**
 * 获取 R2 上传预签名 URL（用于上传文件）
 */
export const commonServiceGetR2PresignedPutUrl = <ThrowOnError extends boolean = false>(options: Options<CommonServiceGetR2PresignedPutUrlData, ThrowOnError>) => {
    return (options.client ?? client).post<CommonServiceGetR2PresignedPutUrlResponses, unknown, ThrowOnError>({
        url: '/v2/console/r2-presigned-put-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};
